/** Values of the `returned_orders.STATUS` column, in the order of the return lifecycle. */
export const ReturnStatuses = ['awaiting', 'received', 'confirmed', 'canceled'];

export const returnReasons = {
    exchange: 'exchange',
    nofit: 'nofit',
    changemind: 'changemind',
    nolike: 'nolike',
    undeliverable: 'undeliverable',
    late: 'late',
    damaged: 'damaged',
    unknown: 'unknown',
};

export const resolutions = {
    returnToInventory: 'returnToInventory',
    receiveAsDamaged: 'receiveAsDamaged',
    restoredToOriginal: 'restoredToOriginal',
    failedRestoredToOriginal: 'failedRestoredToOriginal',
    differentLook: 'differentLook',
    disposal: 'disposal',
    dryCleaning: 'dryCleaning',
    signsOfUse: 'signsOfUse',
};
